import React from "react";
import { Target, ShoppingBag, Settings, TrendingUp, Medal } from "lucide-react";

// ServicesPreview Component
const ServicesPreview = () => {
  const services = [
    {
      icon: <Target size={20} color="#0891b2" />,
      title: "Custom Ball Drilling",
      description:
        "Professional drilling tailored to your bowling style and hand measurements.",
      price: "Starting at $45",
    },
    {
      icon: <ShoppingBag size={20} color="#0891b2" />,
      title: "Equipment Sales",
      description:
        "Premium bowling equipment from all major manufacturers at competitive prices.",
      price: "Competitive Pricing",
    },
    {
      icon: <Settings size={20} color="#0891b2" />,
      title: "Ball Maintenance",
      description:
        "Professional maintenance services to keep your equipment performing at its peak.",
      price: "Starting at $15",
    },
    {
      icon: <TrendingUp size={20} color="#0891b2" />,
      title: "Performance Consulting",
      description:
        "Expert advice to help you choose the right equipment and improve your game.",
      price: "Free with Service",
    },
    {
      icon: <Medal size={20} color="#0891b2" />,
      title: "Professional Coaching",
      description:
        "Get professional coaching from 2024 Team Canada member and USBC certified level 1 coach, Sly Yeung, and take your bowling to the next level.",
      price: "N/A",
    },
  ];
  return (
    <section style={{ padding: "4rem 0", backgroundColor: "#f5f5f5" }}>
      <div
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
      >
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#333",
          }}
        >
          Our Services
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1.5rem",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {services.map((service, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "white",
                padding: "2rem",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                borderLeft: "4px solid #0891b2",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateX(5px)";
                e.currentTarget.style.boxShadow = "0 6px 25px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateX(0)";
                e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.06)";
              }}
            >
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                {service.icon}
                {service.title}
              </h3>
              <p
                style={{
                  color: "#666",
                  marginBottom: "1rem",
                  lineHeight: "1.6",
                }}
              >
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
